import { Image, Pressable, StyleSheet, Text, View, ViewStyle, Platform } from "react-native";
import { color_2A2A2A, color_8C8C8C, color_F1F1F1, color_main, white } from "../../assets/style/colors";
import React from "react";
import { ImageSourcePropType } from "react-native/Libraries/Image/Image";
import { ImageStyle } from "react-native/Libraries/StyleSheet/StyleSheetTypes";
import ArrawIcon from '../../assets/svg/icon_right_arrow.svg'
// Import Switch with platform-specific handling for web
import WebSwitch from '../../utils/shims/switch';
import { Switch as NativeSwitch } from 'react-native';

const Switch = Platform.OS === 'web' ? WebSwitch : NativeSwitch;
type RightType = "Back" | "Switch" | "None"

interface CommonSettingProps {
    itemOption: CommonSettingItemProps[],
    style?: ViewStyle,
}

export interface CommonSettingItemProps {
    text: String,
    textSize?: number,
    subText?: String,
    subTextSize?: number,
    onClick?: (index: number) => void,
    leftIcon?: ImageSourcePropType | undefined
    leftIconStyle?: ImageStyle | undefined
    rightType?: RightType,
    rightText?: String,
    switchChange?: (value: boolean) => void,
    switchIsEnabled?: boolean,
    setIsEnabled?: (enabled: boolean) => void,
    visible?: boolean,
    rightComponent?: React.ReactNode | undefined
}

const SettingItem = (option: CommonSettingItemProps) => {
    const {
        rightComponent,
        text,
        textSize,
        subText,
        subTextSize,
        rightText,
        rightType,
        leftIcon,
        leftIconStyle,
        switchChange,
        setIsEnabled
    } = option;
    
    const toggleSwitch = (value: boolean) => {
        console.log('[CommonSetting] toggleSwitch called with value:', value, 'switchChange exists:', !!switchChange, 'setIsEnabled exists:', !!setIsEnabled);
        // switchChange should handle both state update and API call
        if (switchChange) {
            console.log('[CommonSetting] Calling switchChange');
            switchChange(value);
        } else if (setIsEnabled) {
            console.log('[CommonSetting] Calling setIsEnabled');
            // Fallback: if no switchChange, just update state
            setIsEnabled(value);
        } else {
            console.warn('[CommonSetting] No switchChange or setIsEnabled provided!');
        }
    };
    
    return (
        <View style={styles.container}>
            <View style={styles.leftContainer}>
                {leftIcon && <Image style={[styles.leftIcon, leftIconStyle]} source={leftIcon} />}
                <View style={styles.textContainer}>
                    {text != null && String(text).trim() !== '' && (
                        <Text
                            numberOfLines={1}
                            ellipsizeMode={'tail'}
                            style={[styles.textStyle, {
                                fontWeight: '500',
                                fontFamily: '',
                                fontSize: textSize ? textSize : 16,
                                marginStart: leftIcon ? 12 : 0
                            }]}>{String(text)}</Text>
                    )}
                    {subText != null && String(subText).trim() !== '' && (
                        <Text style={{ color: color_8C8C8C, fontSize: subTextSize ? subTextSize : 15 }}>{String(subText)}</Text>
                    )}
                </View>
                {rightText != null && String(rightText).trim() !== '' ? (
                    <Text
                        numberOfLines={1}
                        ellipsizeMode={'tail'}
                        style={styles.rightText}>{String(rightText)}</Text>
                ) : null}
            </View>

            {rightType === "Switch" ? (
                <View style={styles.rightContainer} collapsable={false}>
                    <Switch
                        trackColor={{ false: "#e9e9ea", true: color_main, }}
                        thumbColor={white}
                        onValueChange={toggleSwitch}
                        value={option.switchIsEnabled ?? false}
                        style={styles.switch}
                        ios_backgroundColor="#e9e9ea"
                        disabled={false}
                        testID="setting-switch" />
                </View>
            ) : rightType === "Back" ? (
                <View style={styles.rightContainer}>
                    <ArrawIcon height={18} width={18} />
                </View>
            ) : rightComponent ? (
                <View style={styles.rightContainer}>
                    {typeof rightComponent === 'string' ? (
                        <Text style={styles.rightText}>{rightComponent}</Text>
                    ) : (
                        rightComponent
                    )}
                </View>
            ) : null}
        </View >);
};
export const CommonSetting = (props: CommonSettingProps) => {
    const { itemOption, style } = props;
    return (
        <View style={[{
            borderRadius: 10,
            backgroundColor: "white"
        }, style]}>
            {itemOption.map((item, index) => {
                if (item.visible === false) {
                    return null;
                }
                // For Switch items, don't wrap in Pressable to allow switch to handle touches
                if (item.rightType === "Switch") {
                    return (
                        <View key={index.toString()}>
                            <View style={styles.pressableContainer}>
                                <SettingItem {...item} />
                            </View>
                            {(index < itemOption.length - 1) &&
                                <View style={styles.separator} />}
                        </View>
                    );
                }
                
                return (
                    <View key={index.toString()}>
                        <Pressable
                            onPress={() => {
                                if (item.onClick) {
                                    item.onClick(index);
                                }
                            }}
                            style={styles.pressableContainer}>
                            <SettingItem {...item} />
                        </Pressable>
                        {(index < itemOption.length - 1) &&
                            <View style={styles.separator} />}
                    </View>
                );
            })}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        flexDirection: "row",
        paddingHorizontal: 20,
        justifyContent: 'space-between',
        minHeight: 44,
        overflow: 'visible',
    },
    leftIcon: {
        width: 20,
        height: 20,
        objectFit: 'contain',
    },
    textStyle: {
        color: color_2A2A2A,
        textAlignVertical: 'center'
    },
    leftContainer: {
        flex: 1,
        alignItems: 'center',
        flexDirection: "row",
        marginRight: 12,
    },
    textContainer: {
        flex: 1,
    },
    rightContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 50,
        zIndex: 10,
    },
    switch: {
        transform: [{ scaleX: 1 }, { scaleY: 1 }],
    },
    rightText: {
        color: color_8C8C8C,
        fontSize: 15,
        marginStart: 8,
        maxWidth: 120
    },
    pressableContainer: {
        minHeight: 60,
        justifyContent: 'center',
        paddingVertical: 8,
        overflow: 'visible',
    },
    separator: {
        height: 1,
        backgroundColor: color_F1F1F1,
        marginLeft: 20,
    },
})
